import { useParams, useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './ItemPage.css';
import RocketDocsImage from './img/rocket-docs.jpg';
import PilotAcademyImage from './img/pilot-academy.jpg';
import MissionControlImage from './img/mission-control.jpg';
import BankImage from './img/bank.jpeg';
import CommHQImage from './img/comm-hq.jpg';

const images = [
  RocketDocsImage, PilotAcademyImage, MissionControlImage, RocketDocsImage, BankImage, RocketDocsImage,
  CommHQImage
];

const ItemPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="item-page">
      <img src={images[id-1]} alt={`Image ${id}`} className="item-image" />
      <BackButton onClick={() => navigate('/fork')} />
    </div>
    
  );
};

export default ItemPage;